import moment from "moment/moment";

angular.module('clientDashboardApp')
  .factory('sharedScoringReportFilters', (
      $state,
      $location,
      locationService,
      ) => {

    let cache = {}
    // this will need rethinking if the reports filters aren't all shared.
    // I'm just lazy right now.
    // something with redux would be better
    const self = {
      persistFilters({
        groupId,
        start,
        end
      }) {
        const params = {
          groupId: groupId,
          start: start && start.format('YYYY-MM-DD'),
          end: end && end.format('YYYY-MM-DD')
        }
        cache = { groupId, start, end }
        $location.search(params);
      },
      restoreFilters() {
        let params = $state.params;
        const filters = {
          start: params.start && moment(params.start) || cache.start || moment().subtract(1, 'day'),
          end: params.end && moment(params.end) || cache.end || moment(),
          groupId: params.groupId || locationService.getSelectedGroupId()
        }
        self.persistFilters(filters)
        return filters
      }

    }
    return self
  })
